import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import DrilldownInput from "components/DrilldownInput";
import { FormLabel } from "@material-ui/core";
import RayTracingSelector from "MetaComponent/selectors/RayTracing";
import DesignSelector from "MetaComponent/selectors/Design";
import RayTracingAction from "MetaComponent/actions/RayTracing";

export const styles = {
  drillDown: {
    marginBottom: 20,
    textAlign: "left"
  }
};

export class RayTracingJobDropdown extends PureComponent {
  componentDidMount() {
    this.init();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selectedDesignJobId !== this.props.selectedDesignJobId) {
      this.init();
    }
  }

  getJobsList = jobs => {
    const { selectedJobId } = this.props;
    return jobs.map(job => {
      const label = this.getJobLabel(job);
      return {
        id: job.id,
        text: label,
        isSelected: job.id === selectedJobId
      };
    });
  };

  getJobLabel = job => {
    return job ? `${job.name} - ${job.status}` : "";
  };

  /**
   * it sets the selected job id in the state
   * @param {String} selectedOptionIndex - the index of the selected option
   * @callback
   */
  onJobSelect = selectedOptionIndex => {
    const { selectJob } = this.props;
    const selectedJobId = parseInt(
      this.props.rayTracingJobs[selectedOptionIndex].id,
      10
    );
    selectJob(selectedJobId);
  };

  /**
   * validates the currently selected analysis job id to make sure it is remembered
   * and it makes sense.
   */
  init() {
    const {
      rayTracingJobs,
      selectedJobId,
      selectedDesignJobId,
      selectJob
    } = this.props;

    const aDesignJobIsSelected = selectedDesignJobId !== null;
    const thereIsRayTracingJob = rayTracingJobs.length > 0;
    const thereIsRayTracingJobThatBelongsToSelectedDesignJob =
      aDesignJobIsSelected &&
      thereIsRayTracingJob &&
      rayTracingJobs.find(job => job.design_job === selectedDesignJobId);
    const thereIsNoSelectedRayTracingJob = selectedJobId === null;
    const selectedRayTracingJobExists =
      !thereIsNoSelectedRayTracingJob &&
      rayTracingJobs.find(job => job.id === selectedJobId);
    const selectedRayTracingJobBelongsToSelectedDesignJob =
      selectedRayTracingJobExists &&
      rayTracingJobs.find(job => job.id === selectedJobId).design_job ===
        selectedDesignJobId;

    if (
      aDesignJobIsSelected &&
      thereIsRayTracingJobThatBelongsToSelectedDesignJob &&
      (thereIsNoSelectedRayTracingJob ||
        !selectedRayTracingJobExists ||
        !selectedRayTracingJobBelongsToSelectedDesignJob)
    ) {
      const last = [...rayTracingJobs]
        .reverse()
        .find(job => job.design_job === selectedDesignJobId);
      selectJob(last.id);
    } else if (
      !aDesignJobIsSelected ||
      !thereIsRayTracingJobThatBelongsToSelectedDesignJob
    ) {
      selectJob(null);
    }
  }

  render() {
    const { rayTracingJobs, classes, selectedJobId } = this.props;
    return (
      <div className={classes.drillDown}>
        <FormLabel>Ray Tracing Job</FormLabel>
        <DrilldownInput
          name="RayTracingJob"
          marginTop={10}
          onClose={(value, data) => {}}
          options={[this.getJobsList(rayTracingJobs)]}
          showCount={false}
          value={
            selectedJobId
              ? this.getJobLabel(
                  rayTracingJobs.filter(job => job.id === selectedJobId)[0]
                )
              : ""
          }
          onSelect={this.onJobSelect}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    selectedJobId: RayTracingSelector.getSelectedJobId(state),
    selectedDesignJobId: DesignSelector.getSelectedJobId(state)
  };
};

const mapDispatchToProps = dispatch => {
  return {
    selectJob: jobId => dispatch(RayTracingAction.selectJob(jobId))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(RayTracingJobDropdown));
